import { getSelectorRoot } from 'utils/selectors';

const getJackpot = getSelectorRoot('jackpot');

export const getCurrentJackpotId = getJackpot('currentJackpotId');
export const getJackpotMetaData = getJackpot('jackpotMetaData');
export const getInternalJackpots = getJackpot('internalJackpots');
export const getExternalJackpots = getJackpot('externalJackpots');
